// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2OqG2","placeholdersHeader":"styles_placeholdersHeader__1pVGn","editorStyle":"styles_editorStyle__19Cpj","placeholdersBox":"styles_placeholdersBox__2pZFc"};